import React, { useEffect } from "react";
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import EngagementCenterTable from "../../../components/Admin/EngagementCenter/EngagementCenterTable/EngagementCenterTable";
import { engagementCenter } from "../../../utils/mainTabs/admin/engagementCenter/engagementCenter";
import { notificationDetails } from "../../../utils/mainTabs/admin/engagementCenter/notificationDetails";
import { notificationHistory } from "../../../utils/mainTabs/admin/engagementCenter/notificationHistory";

const EngagementCenter = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const { tenantName, setAdminNavLinks, setAdminButtons, setAdminTiles } =
    useOutletContext();

  const engagementCenterPath = engagementCenter.path(tenantName);

  useEffect(() => {
    const engagementCenterNavLinks = engagementCenter.navLinks(
      navigate,
      tenantName
    );
    const notificationHistoryPath = notificationHistory.path(tenantName);
    const notificationHistoryNavLinks = notificationHistory.navLinks(
      navigate,
      tenantName
    );

    const notificationDetailsPath = notificationDetails.path(
      location,
      tenantName,
      params?.notificationId
    );
    const notificationDetailsNavLinks = notificationDetails.navLinks(
      navigate,
      tenantName,
      location,
      params?.notificationId
    );
    if (location.pathname === engagementCenterPath) {
      setAdminTiles([]);
      setAdminNavLinks(engagementCenterNavLinks);
      setAdminButtons([]);
    } else if (location.pathname === notificationHistoryPath) {
      setAdminTiles([]);
      setAdminNavLinks(notificationHistoryNavLinks);
      setAdminButtons([]);
    } else if (location.pathname === notificationDetailsPath) {
      setAdminTiles([]);
      setAdminNavLinks(notificationDetailsNavLinks);
      setAdminButtons([]);
    }
  }, [
    tenantName,
    location,
    params,
    navigate,
    setAdminButtons,
    setAdminNavLinks,
    setAdminTiles,
    engagementCenterPath,
  ]);

  return location.pathname === engagementCenterPath ? (
    <EngagementCenterTable />
  ) : (
    <Outlet context={{ tenantName }} />
  );
};

export default EngagementCenter;
